

function genUniqueID(len){
    let generateUniqueID=(len)=>{
        let result = '';
        let alphabet = 'qwertyuiopasdfghjklzxcvbnm1234567890$QWERTYUIOPASDFGHJKLZXCVBNM';
        for (var i = 0; i < len; i++){
            result += alphabet.charAt(Math.floor(Math.random()*alphabet.length));
        }
        return result
    };
    return generateUniqueID(len);
}

// The received data is wrong. Contact support for resolution. Traceback (most recent call last):  File "/usr/share/l.v.e-manager/utils/cloudlinux-cli-user.py", line 16, in     cloudlinux_cli.main()  File "/usr/share/l.v.e-manager/utils/libcloudlinux.py", line 159, in main    self.check_license()  File "/usr/share/l.v.e-manager/utils/libcloudlinux.py", line 370, in check_license    if not self.licence.get_license_status():           ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^  File "/opt/cloudlinux/venv/lib64/python3.11/site-packages/cllicense/license_lib.py", line 27, in get_license_status    p = subprocess.Popen(        ^^^^^^^^^^^^^^^^^  File "/opt/alt/python311/lib64/python3.11/subprocess.py", line 1026, in __init__    self._execute_child(args, executable, preexec_fn, close_fds,  File "/opt/alt/python311/lib64/python3.11/subprocess.py", line 1883, in _execute_child    self.pid = _fork_exec(               ^^^^^^^^^^^OSError: [Errno 12] Cannot allocate memory
function genUniqueNumbers(len){
    let result = '';
    let numbers = '0123456789';
    for (var i = 0; i < len; i++){
        result += numbers.charAt(Math.floor(Math.random()*numbers.length));
    }
    return result*1
}

module.exports = {genUniqueID, genUniqueNumbers};